import cuentasCtrl from './Cuentas/cuentasCtrl';
import nuevaCuentaCtrl from './Cuentas/nuevaCuentaContribuyenteCtrl';
import desactivarCuentaCtrl from './Cuentas/desactivarCuentaContribuyenteCtrl';
import reactivarCuentaCtrl from './Cuentas/reactivarCuentaContribuyenteCtrl';
import cuentaDetalleCtrl from './Cuentas/cuentaDetalleCtrl';

import invitarColaboradorCtrl from './Cuentas/Colaboradores/invitarColaboradorCtrl';

import colaboradoresCtrl from './Colaboradores/colaboradoresCtrl';

export default angular.module('contartemx.administracion', [
    cuentasCtrl.name,
    cuentaDetalleCtrl.name,
    colaboradoresCtrl.name,
    'ui.router'
])
    .config([
        '$stateProvider', ($stateProvider) => {

            $stateProvider.state('administracion', {
                url: '/Administracion',
                abstract: true,
                views: {
                    'submenu': {
                        template: require('../../../../app/views/Administracion/Administracion_submenu.html'),
                    },
                    '': {
                        template: require(`../../../../app/views/MainContainer.html`)
                    }
                },
                resolve: {
                    authorize: ['authorization', authorization => authorization.authorize()],
                }                
            })
                .state('administracion.cuentas', {
                    url: '/Cuentas',
                    views:
                    {
                        'main': {
                            template: require(`../../../../app/views/Administracion/Cuentas/Cuentas_main.html`),
                            controller: 'CuentasCtrl'
                        }
                    },
                })
                .state('administracion.cuenta_detalle', {
                    url: '/Cuenta/:cveContribuyente',
                    views:
                    {
                        'main': {
                            template: require(`../../../../app/views/Administracion/Cuentas/Cuenta_detalle.html`),
                        },
                        'administrar_cuenta@administracion.cuenta_detalle': {
                            template: require(`../../../../app/views/Cuenta/Administrar_Cuenta.html`),
                            controller: 'AdministrarCuentaCtrl',                          
                        },
                        'colaboradores_cuenta@administracion.cuenta_detalle': {
                            template: require(`../../../../app/views/Administracion/Cuentas/Colaboradores/Cuenta_colaboradores.html`),
                            controller: 'CuentaDetalleCtrl'
                        }
                    }
                })
                .state('administracion.colaboradores', {
                    url: '/Usuarios',
                    views:
                    {
                        'main': {
                            template: require(`../../../../app/views/Administracion/Colaboradores/Colaboradores_main.html`),
                            controller: 'AdministracionColaboradoresCtrl'
                        }
                    }
              });
        }
    ]);
